
import { useLazyLoad } from "../../hooks/useLazyLoad";

export default function LazyLoadWrapper({ children, fallbackHeight, className, ...props }) {
  const { ref, isVisible } = useLazyLoad();

  return (
    <div ref={ref} className={className} {...props}>
      {isVisible ? children : <div style={{ height: fallbackHeight, background: "#f0f0f0" }} />}
    </div>
  );
}
